"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMoney = exports.getPageCount = exports.flattenMultidimensionalArray = exports.handlize = exports.random = exports.getHandle = exports.setSearchParm = exports.getSearchParam = exports.debounce = exports.toggleElement = exports.unique = exports.getAlternativeTemplate = exports.$$ = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _Dom = require("common/Dom");

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require("common/Constants");

var _Constants2 = _interopRequireDefault(_Constants);

require("url-search-params-polyfill");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $$ = exports.$$ = function $$(selector) {
  var nodes = document.querySelectorAll(selector);
  return (0, _from2.default)(nodes);
};

var getAlternativeTemplate = exports.getAlternativeTemplate = function getAlternativeTemplate(_ref) {
  var resource = _ref.resource,
      templateName = _ref.templateName,
      _ref$json = _ref.json,
      json = _ref$json === undefined ? false : _ref$json;

  var url = "/" + resource + "?view=" + templateName;
  var options = { credentials: "include" };
  return fetch(url, options).then(function (res) {
    return json ? res.json() : res.text();
  });
};

var unique = exports.unique = function unique(array) {
  return [].concat((0, _toConsumableArray3.default)(new _set2.default(array)));
};

var toggleElement = exports.toggleElement = function toggleElement(_ref2) {
  var selector = _ref2.selector,
      _ref2$className = _ref2.className,
      className = _ref2$className === undefined ? _Dom2.default.isActive : _ref2$className,
      _ref2$action = _ref2.action,
      action = _ref2$action === undefined ? "toggle" : _ref2$action,
      _ref2$animated = _ref2.animated,
      animated = _ref2$animated === undefined ? false : _ref2$animated;

  var normalizedclassName = className[0] === "." ? className.slice(1) : className;
  var normalizedSelectorString = className[0] !== "." ? "." + className : className;

  var impossibleAdd = $(selector).is(normalizedSelectorString) && action == "add";
  var impossibleRemove = !$(selector).is(normalizedSelectorString) && action == "remove";

  if (impossibleAdd || impossibleRemove) {
    return _promise2.default.resolve({});
  }

  var toggleClass = function toggleClass() {
    if (action === "toggle") {
      $(selector).toggleClass(normalizedclassName);
    } else if (action === "add") {
      $(selector).addClass(normalizedclassName);
    } else if (action === "remove") {
      $(selector).removeClass(normalizedclassName);
    }
  };

  if (animated) {
    return new _promise2.default(function (resolve) {
      $(selector).one("transitionend", function () {
        return resolve({ selector: selector, className: className, action: action, animated: animated });
      });
      toggleClass();
    });
  }

  toggleClass();

  return _promise2.default.resolve({ selector: selector, className: className, action: action, animated: animated });
};

var debounce = exports.debounce = function debounce(callback) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var interval = arguments[2];
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(interval);
    interval = setTimeout(function () {
      return callback.apply(undefined, args);
    }, time);
  };
};

var getSearchParam = exports.getSearchParam = function getSearchParam(params) {
  var searchParams = new URLSearchParams(window.location.search);

  return typeof params === "string" ? searchParams.get(params) : params.reduce(function (params, param) {
    return (0, _assign2.default)({}, params, (0, _defineProperty3.default)({}, param, searchParams.get(param.toLowerCase())));
  }, {});
};

var setSearchParm = exports.setSearchParm = function setSearchParm(param, value) {
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set(param, value);
  window.history.pushState("", "", "?" + searchParams.toString());
  return searchParams;
};

var getHandle = exports.getHandle = function getHandle() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "product";

  if (type === "collection") {
    return window.location.pathname.replace(/\/collections\/(.*)\/?/, "$1");
  } else if (type === "product") {
    return window.location.pathname.replace(/\/products\/(.*)\/?/, "$1");
  }
  return window.location.pathname.replace(/\/products\/(.*)\/?/, "$1");
};

var random = exports.random = function random() {
  var digits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9;

  return Math.floor(Math.random() * Math.pow(10, digits));
};

var handlize = exports.handlize = function handlize(string) {
  return string.trim().toLowerCase().replace(/[\s_]/g, "-");
};

/**
 * Flatten multidimension array into singledimension
 * @param {Array Array} array - Multidimensional array to flatten
 * @return {Array} - Flattened array
 */
var flattenMultidimensionalArray = exports.flattenMultidimensionalArray = function flattenMultidimensionalArray(array) {
  // return array.flat();
  // Leave this here in case Array.prototype.flat() causes issues for IE/Safari
  var data = array.reduce(function (data, innerArray) {
    data = data.concat(innerArray);
    return data;
  }, []);
  return data;
};

var getPageCount = exports.getPageCount = function getPageCount(count, pageLimit) {
  return Math.ceil(count / pageLimit);
};

var formatMoney = exports.formatMoney = function formatMoney(cents) {
  var hideZeroCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var formatter = new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: "USD"
  });
  if (cents) {
    var dollars = cents / 100;
    var money = formatter.format(dollars);
    if (hideZeroCents) {
      money = money.replace(".00", "");
    }
    return money;
  }
  return "";
};